// Application constants

export const APP_NAME = 'Clystcore Surveyors'
export const APP_VERSION = '1.0.0'

// Survey statuses
export const SURVEY_STATUS = {
  IN_PROGRESS: 'in-progress',
  COMPLETED: 'completed',
  ANALYSED: 'analysed'
}

export const SURVEY_STATUS_LABELS = {
  'in-progress': 'In Progress',
  'completed': 'Completed',
  'analysed': 'Analysed'
}

export const SURVEY_STATUS_COLORS = {
  'in-progress': 'bg-amber-100 text-amber-800',
  'completed': 'bg-blue-100 text-blue-800',
  'analysed': 'bg-green-100 text-green-800'
}

// Default surveyor
export const DEFAULT_SURVEYOR = 'Chris I Baker'

// Category icons mapping (Lucide icon names)
export const CATEGORY_ICONS = {
  'home': 'Home',
  'trees': 'Trees',
  'warehouse': 'Warehouse',
  'utensils': 'Utensils',
  'sofa': 'Sofa',
  'bed-double': 'BedDouble',
  'bed': 'Bed',
  'bath': 'Bath',
  'shower-head': 'ShowerHead',
  'door-open': 'DoorOpen',
  'flower-2': 'Flower2',
  'car': 'Car',
  'gauge': 'Gauge',
  'plus': 'Plus',
  'folder': 'Folder'
}

// Available icons for category selection
export const AVAILABLE_ICONS = [
  { value: 'home', label: 'Home' },
  { value: 'trees', label: 'Trees' },
  { value: 'warehouse', label: 'Warehouse' },
  { value: 'utensils', label: 'Kitchen/Utensils' },
  { value: 'sofa', label: 'Sofa/Living Room' },
  { value: 'bed-double', label: 'Double Bed' },
  { value: 'bed', label: 'Bed' },
  { value: 'bath', label: 'Bath' },
  { value: 'shower-head', label: 'Shower' },
  { value: 'door-open', label: 'Door' },
  { value: 'flower-2', label: 'Garden/Flower' },
  { value: 'car', label: 'Car/Garage' },
  { value: 'gauge', label: 'Utilities/Gauge' },
  { value: 'folder', label: 'General/Folder' },
  { value: 'camera', label: 'Camera' },
  { value: 'image', label: 'Image' },
  { value: 'building', label: 'Building' },
  { value: 'hammer', label: 'Tools/Repair' },
  { value: 'thermometer', label: 'Temperature/Heating' },
  { value: 'droplets', label: 'Water/Plumbing' }
]

// Color palette for the app
export const COLORS = {
  primary: {
    50: '#f0f5fa',
    100: '#dae5f2',
    200: '#b8cee6',
    300: '#8ab0d5',
    400: '#5a8ec1',
    500: '#3a71a8',
    600: '#2d5a8c',
    700: '#1e3a5f',
    800: '#1a3250',
    900: '#162a42'
  },
  secondary: {
    50: '#f0fdfa',
    100: '#ccfbf1',
    200: '#99f6e4',
    300: '#5eead4',
    400: '#2dd4bf',
    500: '#14b8a6',
    600: '#0d9488',
    700: '#0f766e',
    800: '#115e59',
    900: '#134e4a'
  },
  accent: {
    50: '#fffbeb',
    100: '#fef3c7',
    200: '#fde68a',
    300: '#fcd34d',
    400: '#fbbf24',
    500: '#f59e0b',
    600: '#d97706',
    700: '#b45309',
    800: '#92400e',
    900: '#78350f'
  }
}

// Routes
export const ROUTES = {
  HOME: '/',
  NEW_SURVEY: '/survey/new',
  SURVEY: '/survey/:id',
  SURVEY_LIST: '/surveys',
  ADMIN: '/admin',
  ANALYSIS: '/survey/:id/analysis',
  SETTINGS: '/settings'
}

// Navigation items
export const NAV_ITEMS = [
  { path: '/', label: 'Home', icon: 'home' },
  { path: '/surveys', label: 'Surveys', icon: 'clipboard-list' },
  { path: '/survey/new', label: 'New Survey', icon: 'plus-circle' },
  { path: '/admin', label: 'Categories', icon: 'settings' }
]

// Word template field mappings
export const TEMPLATE_FIELDS = {
  PROPERTY_NAME: '{{PROPERTY_NAME}}',
  PROPERTY_ADDRESS: '{{PROPERTY_ADDRESS}}',
  PROPERTY_POSTCODE: '{{PROPERTY_POSTCODE}}',
  SURVEY_DATE: '{{SURVEY_DATE}}',
  SURVEYOR_NAME: '{{SURVEYOR_NAME}}',
  OVERALL_SUMMARY: '{{OVERALL_SUMMARY}}',
  RECOMMENDATIONS: '{{RECOMMENDATIONS}}'
}

// Image settings
export const IMAGE_CONFIG = {
  maxWidth: 1920,
  maxHeight: 1920,
  quality: 0.85,
  thumbnailSize: 300
}

// API endpoints (for future backend)
export const API_ENDPOINTS = {
  UPLOAD: '/api/upload',
  SURVEYS: '/api/surveys',
  CATEGORIES: '/api/categories',
  ANALYSE: '/api/analyse'
}
